<template>
    <div class="system-message">
        <div class="system-text">
            <template v-if="isAnswerCorrect()">
                <span class="answer-status">
                    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.6485 2.61306L5.31801 9.13755C4.84923 9.62082 4.08879 9.62082 3.61956 9.13755L0.351719 5.76908C-0.11724 5.28581 -0.11724 4.50193 0.351719 4.01856C0.820766 3.53511 1.58114 3.53511 2.04998 4.01838L4.46904 6.51177L9.94997 0.862453C10.419 0.378999 11.1795 0.379365 11.6483 0.862453C12.1172 1.34582 12.1172 2.12943 11.6485 2.61306Z" fill="#10CD00"/>
                    </svg>
                    <span v-html="message.data.data.text"></span>
                </span>
            </template>

            <template v-if="isAnswerWrong()">
                <span class="answer-status">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.31926 0.964276C7.81813 0.456175 8.62697 0.456175 9.12584 0.964276C9.62472 1.47238 9.62472 2.29617 9.12584 2.80427L2.68073 9.11892C2.18186 9.62703 1.37303 9.62703 0.874155 9.11892C0.375282 8.61082 0.375282 7.78703 0.874155 7.27893L7.31926 0.964276Z" fill="#EB5757"/>
                        <path d="M0.931203 2.72107C0.43233 2.21297 0.432331 1.38918 0.931204 0.881076C1.43008 0.372975 2.23891 0.372975 2.73778 0.881076L9.12585 7.19567C9.62472 7.70377 9.62472 8.52757 9.12584 9.03567C8.62697 9.54377 7.81814 9.54377 7.31926 9.03567L0.931203 2.72107Z" fill="#EB5757"/>
                    </svg>
                    <span v-html="message.data.data.text"></span>
                </span>
            </template>

            <template v-if="isActionCustom()">
                <span v-html="message.data.data.text"></span>
            </template>
        </div>
    </div>
</template>

<script>
const ACTION_ANSWER_CORRECT = 1;
const ACTION_ANSWER_WRONG = 2;
const ACTION_CUSTOM = 3;

export default {
    props: {
        message: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            ACTION_ANSWER_CORRECT: ACTION_ANSWER_CORRECT,
            ACTION_ANSWER_WRONG: ACTION_ANSWER_WRONG,
            ACTION_CUSTOM: ACTION_CUSTOM,
        }
    },

    methods: {
        /** Тип - верный ответ */
        isAnswerCorrect()
        {
            return this.message.data.action === this.ACTION_ANSWER_CORRECT;
        },

        /** Тип - неверный ответ */
        isAnswerWrong()
        {
            return this.message.data.action === this.ACTION_ANSWER_WRONG;
        },

        /** Тип - кастомное сообщение */
        isActionCustom()
        {
            return this.message.data.action === this.ACTION_CUSTOM;
        },
    }
}
</script>

<style scoped></style>
